import Controller from '../abstracts/Controller';
import 'scss-templates/t-sizeguide.scss';

export default class SizeGuideController extends Controller {
  static get COMPONENTS() {
    return [
      'SizeTableSwitcherComponent',
      'SizeRowComponent',
      'DropdownComponent',
      'NewsletterComponent',
    ];
  }

  checkRowHeight() {
    // rows
    let rows = $('.l-s-g__size-row.show .l-s-g__size-row__sizes');
    if (rows.length > 0) {
      // let's cycle the rows
      rows.each(function(){
        // reset
        $(this).css({'min-height':'auto'});
        // check if is mobile
        if ($( window ).width() > 768) return true;
        // check the heights
        let before_h = window.getComputedStyle($(this)[0],':before').getPropertyValue('height');
        let row_h = $(this).outerHeight();
        // it the header is in 2 lines
        if (parseInt(before_h, 10) > row_h) {
          let h_to_put = Math.max(parseInt(before_h, 10),row_h);
          $(this).css({'min-height':h_to_put});
        }
      });
    }
  }

  bindEvents() {
    let _this = this;
    // i check the tables on small devices
    _this.checkRowHeight();
    // and on resize
    $(window).resize(function() {
      _this.checkRowHeight();
    });
    // on open size blocks
    $('.l-s-g__size-type-row__head button').on('click',function(){
      setTimeout(function(){
        _this.checkRowHeight();
      },501);
    });
  }

  init() {
    super.init();
    $('.jsSizeGuideLayer').show();
    this.bindEvents();
  }
}
